import React from 'react';
import { CFMediaLayoutStyle } from '@types';
import { Dropdown, type DropdownItem } from '@components/Dropdown';

type Props = {
  className?: string;
  value: CFMediaLayoutStyle;
  withSplitOption?: boolean;
  onChange: (value: CFMediaLayoutStyle) => void;
};

const items: DropdownItem<CFMediaLayoutStyle>[] = [
  { id: CFMediaLayoutStyle.list, name: '列表模式（多图时）' },
  { id: CFMediaLayoutStyle.waterfall, name: '瀑布流模式（多图时）' },
  { id: CFMediaLayoutStyle.bigPic, name: '大图切换模式' },
];

const itemsPlus: DropdownItem<CFMediaLayoutStyle>[] = [
  ...items,
  { id: CFMediaLayoutStyle.splitScreen, name: '图文分屏模式' },
];

export function LayoutSetting({
  className,
  value,
  onChange,
  withSplitOption,
}: Props) {
  return (
    <Dropdown
      className={className}
      items={withSplitOption ? itemsPlus : items}
      selected={value}
      onChange={onChange}
    />
  );
}
